import React from "react";

import "./index.scss";

interface CashBackNotifyProps {
}

const CashBackNotify: React.FC<CashBackNotifyProps> = (props: CashBackNotifyProps) => {
  return (
    <div className="a-notify-promotion">
      Hoàn trả 50% giá trị nếu Quý khách không có nhu cầu sử dụng sản phẩm hoặc dịch vụ ưu đãi sau:
    </div>
  );
};

CashBackNotify.defaultProps = {
};

export default CashBackNotify;
